import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return { container: css`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 28px;

        ${theme.breakpoints.down('md')} {
            grid-template-columns: 1fr 1fr;
            padding: ${theme.spacing(4)}px ${theme.spacing(0)}px;
        }

        ${theme.breakpoints.down('sm')} {
            grid-template-columns: 1fr;
        }
    ` }
}

export default styles
